export default "__VITE_ASSET__BP$LZHi0__"